module.exports = __webpack_public_path__ + "static/media/8.d4faf5b2.png";